import { ComponentProps } from 'react';

import HiddenField from '../../../../../components/HiddenField/HiddenField';
import Row from '../../../../../components/Row/Row';
import Select from '../../../../../components/Select/Select';
import Text from '../../../../../components/Text/Text';
import useTrans from '../../../../../hooks/ui/useTrans';
import useRangeAsOptions from '../../../../hooks/useRangeAsOptions';

type NumberOfBoatsSelectProps = {
    max: number;
    value: number;
    onChange: (value: number) => void;
} & Omit<ComponentProps<typeof Select>, 'options' | 'onChange' | 'value'>;

const NumberOfBoatsSelect = ({
    max,
    value,
    name,
    onChange,
    ...selectProps
}: NumberOfBoatsSelectProps) => {
    const trans = useTrans('CustomerArea.BookingForm.NumberOfBoatsSelect.');
    const numberOfBoatsOptions = useRangeAsOptions(1, max, (x) => x.toString());

    if (max === 1) {
        return <HiddenField name={name} value="1" />;
    }

    return (
        <Row vertical="middle">
            <Text subdued size="small">
                {trans('QuantityLabel')}
            </Text>
            <Select
                {...selectProps}
                name={name}
                options={numberOfBoatsOptions}
                value={value.toString()}
                onChange={(value) => onChange(parseInt(value))}
            />
        </Row>
    );
};

export default NumberOfBoatsSelect;
